@for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [header]="toast.headertext"
    [class]="toast.classname"
    [autohide]="toast.autohide"
    [delay]="toast.delay || 5000"
    (hidden)="toastService.remove(toast)"
  >
    @if (isTemplate(toast)) {
      <ng-template
        [ngTemplateOutlet]="toast.textOrTpl"
        [ngTemplateOutletContext]="{ toast: toast, toastService: toastService, content: toast.content }"
      ></ng-template>
    } @else {
      {{ toast.textOrTpl }}
    }
  </ngb-toast>
}
